function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled, { css } from 'styled-components';
import { fontStyle, spacing, breakpoints, themeLight } from '@naf/theme';
import { Button } from '@naf/button';
import { ButtonLink } from '@naf/button-link';
import { Text, TextVariant } from '@naf/text';
import { CheckCircle } from '@styled-icons/material/CheckCircle';
import { Error } from '@styled-icons/material/Error';
import { Info } from '@styled-icons/material-outlined/Info';
import { ReportProblem } from '@styled-icons/material-outlined/ReportProblem';
import { propValidationConfig } from './propValidationConfig';
export let UserInteractionVariant = /*#__PURE__*/function (UserInteractionVariant) {
  UserInteractionVariant["Success"] = "success";
  UserInteractionVariant["Error"] = "error";
  UserInteractionVariant["Warning"] = "warning";
  UserInteractionVariant["Info"] = "info";
  UserInteractionVariant["Outline"] = "outline";
  return UserInteractionVariant;
}({});
const Icon = ({
  icon,
  variant
}) => {
  let iconVariant = '';
  if (icon) {
    iconVariant = icon;
  } else iconVariant = variant;
  switch (iconVariant) {
    case UserInteractionVariant.Success:
      return /*#__PURE__*/React.createElement(CheckCircle, {
        size: 24
      });
    case UserInteractionVariant.Error:
      return /*#__PURE__*/React.createElement(Error, {
        size: 24
      });
    case UserInteractionVariant.Warning:
      return /*#__PURE__*/React.createElement(ReportProblem, {
        size: 24
      });
    case UserInteractionVariant.Info:
      return /*#__PURE__*/React.createElement(Info, {
        size: 24
      });
    case UserInteractionVariant.Outline:
      return /*#__PURE__*/React.createElement(ReportProblem, {
        size: 24
      });
    default:
      return null;
  }
};
export const UserInteraction = ({
  variant = UserInteractionVariant.Success,
  icon,
  maxWidth,
  title,
  button,
  buttonLink,
  children,
  className
}) => {
  return /*#__PURE__*/React.createElement(Container, {
    className: className,
    maxWidth: maxWidth,
    variant: variant,
    icon: icon
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    variant: variant
  }), /*#__PURE__*/React.createElement(Content, null, title && /*#__PURE__*/React.createElement(Title, {
    variant: TextVariant.ArticleTextHeader
  }, title), /*#__PURE__*/React.createElement(Body, null, children), (button || buttonLink) && /*#__PURE__*/React.createElement(ButtonContainer, {
    isLoading: button && button.isLoading
  }, button && /*#__PURE__*/React.createElement(Button, _extends({
    variant: "outline",
    size: "small"
  }, button)), buttonLink && !button && /*#__PURE__*/React.createElement(ButtonLink, _extends({
    variant: variant === 'info' ? 'primary' : 'secondary'
  }, buttonLink)))));
};
const Container = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "user-interaction__Container",
  componentId: "sc-10q7ju-0"
})(["padding:", " ", ";display:flex;width:calc(100% - (2 * ", "));> svg{margin-right:", ";@media (min-width:", "){padding-top:1.5px;}}", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " @media (max-width:", "){padding:", " ", ";}"], spacing.space32, spacing.space24, spacing.space24, spacing.space12, breakpoints.s, ({
  maxWidth
}) => maxWidth && css(["max-width:", "px;"], maxWidth), ({
  variant
}) => variant === 'success' && css(["background:", ";svg{color:", ";}"], ({
  theme
}) => theme.background ? theme.background.brand : themeLight.background.brand, ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.success : themeLight.componentColors.alert.success), ({
  variant
}) => variant === 'error' && css(["background:", ";svg{color:", ";}"], ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.errorBackground : themeLight.componentColors.alert.errorBackground, ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.error : themeLight.componentColors.alert.error), ({
  variant
}) => variant === 'warning' && css(["background:", ";svg{color:", ";}"], ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.warningBackground : themeLight.componentColors.alert.warningBackground, ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.warning : themeLight.componentColors.alert.warning), ({
  variant
}) => variant === 'info' && css(["background:", ";svg{color:", ";}"], ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.infoLight : themeLight.componentColors.alert.infoLight, ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.info : themeLight.componentColors.alert.info), ({
  variant
}) => variant === 'outline' && css(["background:'transparent';border:1px solid ", ";svg{color:", ";}"], ({
  theme
}) => theme.border ? theme.border.heavy : themeLight.border.heavy, ({
  theme
}) => theme.typography ? theme.typography.subtleText : themeLight.typography.subtleText), ({
  icon
}) => icon === 'success' && css(["svg{color:", ";}"], ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.success : themeLight.componentColors.alert.success), ({
  icon
}) => icon === 'error' && css(["svg{color:", ";}"], ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.error : themeLight.componentColors.alert.error), ({
  icon
}) => icon === 'info' && css(["svg{color:", ";}"], ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.info : themeLight.componentColors.alert.info), ({
  icon
}) => icon === 'warning' && css(["svg{color:", ";}"], ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.warning : themeLight.componentColors.alert.warning), ({
  icon
}) => icon === 'outline' && css(["svg{color:", ";}"], ({
  theme
}) => theme.typography ? theme.typography.subtleText : themeLight.typography.subtleText), breakpoints.s, spacing.space24, spacing.space16);
const Content = styled.div.withConfig({
  displayName: "user-interaction__Content",
  componentId: "sc-10q7ju-1"
})(["", ";display:flex;flex:1;flex-wrap:wrap;"], fontStyle.bodyText.bodyText);
const Title = styled(Text).withConfig({
  displayName: "user-interaction__Title",
  componentId: "sc-10q7ju-2"
})(["margin:0;padding-bottom:", ";flex-basis:100%;@media (max-width:", "){", ";}"], spacing.space8, breakpoints.s, fontStyle.bodyText.bodyTextHeader);
const Body = styled.span.withConfig({
  displayName: "user-interaction__Body",
  componentId: "sc-10q7ju-3"
})(["display:flex;flex-basis:100%;", ";@media (max-width:", "){", ";}"], fontStyle.article.articleText, breakpoints.s, fontStyle.bodyText.bodyText);
const ButtonContainer = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "user-interaction__ButtonContainer",
  componentId: "sc-10q7ju-4"
})(["margin-top:", ";button{", "}"], spacing.space24, ({
  isLoading
}) => isLoading && css(["background-color:transparent !important;"]));
//# sourceMappingURL=user-interaction.js.map